import React, {Component} from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { withRouter } from "../utils/withRouter";
import cart from "../models/cart-model";
import CartTicket from "../components/cart-ticket";
import CartEvent from "../components/cart-event";
import signalDispatcherInstance from "../utils/signalDispatcher";
import CommonService from "../services/common.service";
import userEventService from "../services/user-event.service";

let common = new CommonService();
interface CartPageState {
    cart: cart;
    timeLeft?: string;
    translations: Record<string, any>;
}

interface CartPageProps {
    params: {
        id: string;
    };
}

class CartPage extends Component<CartPageProps, CartPageState> {
    constructor(props: CartPageProps) {
        super(props);
        let cartData = localStorage.getItem('cart');
        let initialCart = cartData ? JSON.parse(cartData) : { cartId: '0', currency: 'HUF', totalPrice: '0' };
        this.state = {
            cart: initialCart,
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'cart_page_open');
        this.setState({ timeLeft: this.getTimeToLeft() });
        setInterval(() => {
            this.setState({ timeLeft: this.getTimeToLeft() });
        }, 1000);
        signalDispatcherInstance.on('updateCartTicket', (updatedTickets: Array<any>) => {
            let updatedCart = { ...this.state.cart, tickets: updatedTickets };
            this.setState({ cart: updatedCart });
            localStorage.setItem('cart', JSON.stringify(updatedCart));
        });
        signalDispatcherInstance.on('updateCartEvent', (updatedEvents: Array<any>) => {
            let updatedCart = { ...this.state.cart, events: updatedEvents };
            this.setState({ cart: updatedCart });
            localStorage.setItem('cart', JSON.stringify(updatedCart));
        });
    }

    componentWillUnmount(): void {
        signalDispatcherInstance.off('updateCartTicket', () => {});
        signalDispatcherInstance.off('updateCartEvent', () => {});
    }

    private getTimeToLeft() {
        const cartData = localStorage.getItem('cart');
        if (cartData) {
            const storedExpiryTime = localStorage.getItem('cartExpiryTime');
            if (storedExpiryTime) {
                const expiryTime = parseInt(storedExpiryTime);
                if (expiryTime > 0) {
                    const minutes = Math.floor(expiryTime / 60);
                    const seconds = expiryTime % 60;
                    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                }
            }
        }
        return '00:00';
    }

    private formatPrice(price: number) {
        return price !== null ? price.toLocaleString() : '';
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private getTotalPrice() {
        let total = 0;
        if (this.state.cart) {
            if (this.state.cart.tickets) {
                total += this.state.cart.tickets.reduce((sum, ticket) => sum + ((ticket.price as number) * ticket.quantity), 0);
            }
            if (this.state.cart.events) {
                this.state.cart.events.forEach(event => {
                    total += (event.ages?.adult ?? 0) * (event.agePrices?.adult ?? 0);
                    total += (event.ages?.junior ?? 0) * (event.agePrices?.junior ?? 0);
                    total += (event.ages?.child ?? 0) * (event.agePrices?.child ?? 0);
                });
                this.state.cart.events.forEach(event => {
                    if (event && event.mealsList && event.mealsList.length > 0) {
                        event.mealsList.forEach(meal => {
                            if (meal.price_huf && meal.quantity) {
                                total += meal.price_huf * meal.quantity;
                            }
                        });
                    }
                });
            }
        }
        return this.formatPrice(total);
    }

    private resetCart() {
        localStorage.removeItem('cart');
        localStorage.removeItem('cartExpiryTime');
        localStorage.removeItem('uuid');
        //signalDispatcherInstance.emit('refreshCartCount', 0);
        common.getUID().then((uid: any) => {
            if (uid && uid.uuid) {
                localStorage.setItem('uuid', uid.uuid);
            }
            else {
                localStorage.setItem('uuid', '');
            }
            window.location.href = '/';
        });
    }

    render() {
        return (
            <Container className="oc-cart">
                <Row key={1} className="oc-page-title">
                    <Col lg={8} md={12} sm={12} xs={12}>
                        <h2>{this.state.translations.filter((item: any) => item.setting_name === 'CART')[0].setting_value_text}</h2>
                    </Col>
                    {this.state.timeLeft && parseInt(this.state.timeLeft) > 0 &&
                    <Col lg={4} md={12} sm={12} xs={12} className="oc-text-timer">
                        {this.state.translations.filter((item: any) => item.setting_name === 'REMAINING_TIME')[0].setting_value_text}: <strong>{this.state.timeLeft || '00:00'}</strong>
                    </Col>
                    }
                </Row>
                {((this.state.cart && this.state.cart.tickets && this.state.cart.tickets.length > 0) || (this.state.cart && this.state.cart.events && this.state.cart.events.length > 0)) &&
                <Row key={2} className="oc-cart-checkout">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <Button variant="primary" className="oc-btn-checkout" onClick={() => this.navigatePage('/checkout')}>{this.state.translations.filter((item: any) => item.setting_name === 'PROCEED_TO_CHECKOUT')[0].setting_value_text}</Button>
                        <Button onClick={() => this.resetCart()} variant="primary" className="oc-btn-checkout mr-2">{this.state.translations.filter((item: any) => item.setting_name === 'CLEAR_CART')[0].setting_value_text}</Button>
                    </Col>
                </Row>
                }
                <Row key={3} className="oc-cart-items">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        {this.state.cart && this.state.cart.tickets && this.state.cart.tickets.length > 0 &&
                            <CartTicket key={'tickets'} tickets={this.state.cart.tickets} />
                        }
                        {this.state.cart && this.state.cart.events && this.state.cart.events.length > 0 &&
                            <CartEvent key={'events'} events={this.state.cart.events} />
                        }
                        {(!this.state.cart || (!this.state.cart.tickets || this.state.cart.tickets.length === 0) && (!this.state.cart.events || this.state.cart.events.length === 0)) &&
                            <p className="cart-is-empty">{this.state.translations.filter((item: any) => item.setting_name === 'EMPTY_CART')[0].setting_value_text}...</p>
                        }
                    </Col>
                </Row>
                {((this.state.cart && this.state.cart.tickets && this.state.cart.tickets.length > 0) || (this.state.cart && this.state.cart.events && this.state.cart.events.length > 0)) &&
                <Row key={4} className="oc-cart-total">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <div>
                            <h4>{this.state.translations.filter((item: any) => item.setting_name === 'TOTAL_PRICE')[0].setting_value_text}: </h4>
                            <h3>
                                {this.getTotalPrice()} HUF <small>({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</small>
                            </h3>
                        </div>
                        <div>
                            <Button variant="primary" className="oc-btn-checkout separate" onClick={() => this.navigatePage('/checkout')}>{this.state.translations.filter((item: any) => item.setting_name === 'PROCEED_TO_CHECKOUT')[0].setting_value_text}</Button>
                        </div>
                    </Col>
                </Row>
                }
            </Container>
        );
    }
}

export default withRouter(CartPage);